<div *ngIf="!isVerificationSuccess; else validAccountContainer" class="form-page">
  <div class="form-header">
    <a class="title active">{{ 'auth.verification' | translate }}</a>
    <div class="subtitle">{{ 'auth.code' | translate }}</div>
  </div>
  <form #loginData="ngForm" class="form-body" (ngSubmit)="verifyAccount()">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'account.email' | translate }}</mat-label>
      <input matInput type="email" [(ngModel)]="email" name="email" autocomplete="email" required />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'account.code' | translate }}</mat-label>
      <input matInput type="text" [(ngModel)]="code" name="code" autocomplete="code" required />
    </mat-form-field>
    <button
      mat-raised-button
      color="primary"
      class="mb"
      [disabled]="!loginData.valid || processing"
      type="submit">
      {{ 'auth.verify' | translate }}
    </button>
    <button
      class="mb"
      mat-raised-button
      (click)="resendCode()"
      [disabled]="processing || countdown() !== 0">
      {{ 'auth.resendCode' | translate }}{{ countdown() ? ' (' + countdown() + ')' : '' }}
    </button>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </form>
</div>
<ng-template #validAccountContainer>
  <div *ngIf="isVerificationSuccess" class="success">
    <div>
      <mat-icon class="icon-success" color="primary">task_alt</mat-icon>
      <p class="success-message">{{ 'auth.verified' | translate }}</p>
      <button class="mb btn-login" mat-raised-button (click)="redirectToLogin()">
        {{ 'auth.logIn' | translate }}
      </button>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </div>
</ng-template>
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
